export default __webpack_public_path__ + "static/media/bl.2b7587ab.svg";